import api from "../index";

const multipartHeaders = {
  headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
};

const toTicketChatFormData = (data) => {
  if (data instanceof FormData) return data;

  const formData = new FormData();
  const ticketId = data?.TicketId ?? data?.ticketId;
  const userComments = data?.UserComments ?? data?.userComments ?? data?.userComment ?? "";
  const adminComments = data?.AdminComments ?? data?.adminComments ?? data?.adminComment ?? "";
  const files = data?.FileName ?? data?.fileName;

  if (ticketId != null) formData.append("TicketId", ticketId);
  formData.append("UserComments", userComments ?? "");
  formData.append("AdminComments", adminComments ?? "");

  if (files) {
    const fileList = Array.isArray(files) ? files : [files];
    fileList.forEach((file) => {
      if (file) formData.append("FileName", file);
    });
  }

  return formData;
};

export const GetAllTicketApi = (params) => api.get(`TicketMaster/GetTicketList-ByUserId?${params}`);
export const GetTicketPriorityApi = () => api.get('DropDown/Priority');
export const GetTicketQueryTypeApi = (params) => api.get(`DropDown/Ticket-Query?${params}`);
export const GenerateTicketApi = (data) => api.post('TicketMaster/Generate-Ticket', data);
export const GetTicketByIdApi = (params) => api.get(`TicketMaster/GetTicket-ByTicketId?${params}`);
export const GetTicketChatApi = (data) =>
  api.post('TicketMaster/AddOrGet-ChatByTicketId', toTicketChatFormData(data), multipartHeaders);
export const UpdateTicketApi = (data) => api.post('TicketMaster/Update-Ticket', data);
